<template>


    <!-- Cities -->
    <ul  v-if="isCities" class="search-results__locations">
        <li :key="i" v-for="(city, i) in this.results">
            <a :href='`/destination/${city.slug}`'>
                <img class='':src="city.thumb_feat_img" v-rjs="2">
                {{ city.title }}
            </a>
        </li>
    </ul>

    <!-- Memers -->
    <ul v-else-if="isMembers" class="search-results__members">

        <!-- No Results -->
        <li class="no-results" v-if="!this.results.length">
            No Results
        </li>

        <li v-for="user in this.results" :key="`members-${user.id}`" >
            <a :href="`/${user.username}`">
                <img :src="user.profile_thumbnail" v-rjs="2">
                <span>
                    {{ user.full_name }}
                    <verified-badge v-if="user.is_verified" />
                </span>
            </a>
        </li>
    </ul>

    <!-- Posts -->
    <ul v-else-if="isPosts" class="search-results__posts">

        <!-- No Results -->
        <li class="no-results" v-if="!this.results.length">
            No Results
        </li>

        <li v-for="post in this.results":key="`posts-${post.id}`" >
            <a :href="`/journal/${post.slug}`" class="img-wrap">
                <img :src="post.image">
            </a>
            <div class="content">
                <small>
                    <a :href="`/journal/category/${post.category.slug}`"
                       v-text="post.category.name">
                    </a>
                </small>
                <h2>
                    <a :href="`/journal/${post.slug}`" v-text="post.name"></a>
                </h2>
                <small v-if="post.user">
                    <em>By</em> <a :href="`/${post.user.username}`" v-html="post.user.name"></a>
                </small>
            </div>
        </li>
    </ul>

    <!-- Tags -->
    <ul v-else-if="isTags" class="search-results__tags">

        <!-- No Results -->
        <li class="no-results" v-if="!this.results.length">
            No Results
        </li>

        <li v-for="tag in this.results":key="`tags-${tag.id}`" >
            <div class="content">
                <h2>
                    <a href="#" v-text="tag.name"></a>
                </h2>
                <a href="#" v-text="`Tagged in ${tag.destinations_count} destinations`"></a>
            </div>
        </li>
    </ul>

    <!-- Lists -->
    <ul v-else-if="isLists" class="search-results__lists">

        <!-- No Results -->
        <li class="no-results" v-if="!this.results.length">
            No Results
        </li>

        <li v-for="list in this.results":key="`lists-${list.id}`" >
            <a :href="`/${list.user.username}/list/${list.slug}`" class="img-wrap">
                <img :src="list.cover">
            </a>
            <div class="content">
                <h2>
                    <a :href="`/${list.user.username}/list/${list.slug}`" v-text="list.name"></a>
                </h2>
                <small>
                    <a :href="`/${list.user.username}/list/${list.slug}`" v-html="list.destinations_text"></a>
                </small>
            </div>
        </li>
    </ul>


</template>

<script>

export default {

    props: ['data', 'type', 'limit'],


    data() {
        return {
            results:  this.limit ? _.take(this.data, this.limit) : this.data
        }
    },

    watch:{
        data(){
            this.results = this.limit ? _.take(this.data, this.limit) : this.data
        }
    },

    computed: {

        isMembers(){
            return this.type == 'members';
        },

        isPosts(){
            return this.type == 'posts';
        },

        isCities(){
            return this.type == 'cities';
        },

        isLists(){
            return this.type == 'lists';
        },

        isTags(){
            return this.type == 'tags';
        }
    },


}
</script>
